<template>
  <div class="text-h4 position-relative pa-3">
    {{ value }}
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    }
  }
};
</script>
